import { useEffect } from "react"
import { createRoot } from "react-dom/client"

export const useMapControl = (map, controlPosition, children) => {
  useEffect(() => {
    if (map && controlPosition) {
      const container = document.createElement("div")
      const root = createRoot(container)
      root.render(
        <div
          ref={el => {
            map.controls[controlPosition].clear()
            map.controls[controlPosition].push(el)
          }}
        >
          {children}
        </div>
      )
    }
    return () => {
      if (map && controlPosition) {
        map.controls[controlPosition].clear()
      }
    }
  }, [map, controlPosition, children])
}
